import { Container, Row, Col, Card } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { getStats } from '../api/api';

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getStats();
        if (res.ok) {
          setStats(res.data || {});
          setError(null);
        } else {
          setStats(null);
          setError(res.error || "Errore nel recupero delle statistiche");
        }
      } catch (e) {
        setStats(null);
        setError("Errore di rete nel recupero delle statistiche");
      }
    };
    fetchData();
  }, []);

  const cardStyle = {
    fontSize: '2rem',
    fontWeight: 'bold'
  };

  return (
    <Container className="mt-4">
      <h1 className="mb-4 text-center fw-bold">📊 Dashboard</h1>

      {error && <div className="alert alert-danger">{error}</div>}

      {!stats ? (
        <div className="text-center mt-5">Caricamento...</div>
      ) : (
        <Row className="mb-4 g-4">
          <Col xs={12} sm={6} md={3}>
            <Card bg="primary" text="white" className="shadow h-100 border-0">
              <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                <div style={{ fontSize: '2.5rem' }}>🤸‍♂️</div>
                <Card.Title>Atleti</Card.Title>
                <Card.Text style={cardStyle}>{stats.total_participants}</Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} sm={6} md={3}>
            <Card bg="success" text="white" className="shadow h-100 border-0">
              <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                <div style={{ fontSize: '2.5rem' }}>🏋️‍♂️</div>
                <Card.Title>Allenatori</Card.Title>
                <Card.Text style={cardStyle}>{stats.total_coaches}</Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} sm={6} md={3}>
            <Card bg="info" text="white" className="shadow h-100 border-0">
              <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                <div style={{ fontSize: '2.5rem' }}>🥋</div>
                <Card.Title>Incontri</Card.Title>
                <Card.Text style={cardStyle}>{stats.total_matches}</Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} sm={6} md={3}>
            <Card bg="warning" text="white" className="shadow h-100 border-0">
              <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                <div style={{ fontSize: '2.5rem' }}>🏆</div>
                <Card.Title>Categorie</Card.Title>
                <Card.Text style={cardStyle}>{stats.total_categories}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {stats && stats.matches_per_category && (
        <>
          <h3 className="mt-4 text-center fw-bold">📁 Incontri per categoria</h3>
          <Row className="g-4 mt-2">
            {stats.matches_per_category.map(({ categoria, count }) => (
              <Col xs={12} sm={6} md={4} lg={3} key={categoria}>
                <Card
                  className="shadow-sm h-100 border-0"
                  style={{
                    backgroundColor: "#f0f2f5",
                    transition: "all 0.2s ease-in-out",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#e0e3e7")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "#f0f2f5")
                  }
                >
                  <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                    <Card.Title className="text-primary text-center fw-semibold">
                      {categoria}
                    </Card.Title>
                    <Card.Text
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "bold",
                        color: "#333",
                      }}
                    >
                      {count}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </>
      )}
      
    </Container>
  );
}
